<section class="fixed-header mat-elevation-z8" tabindex="0">
    <table mat-table [dataSource]="dataSource" multiTemplateDataRows class="mat-elevation-z8">
        <ng-container matColumnDef="{{column}}" *ngFor="let column of columnsToDisplay; let indexOfelement=index;">
            <th mat-header-cell *matHeaderCellDef [class.rightAlign]="['count'].includes(column)"
                [class.width24]="column == 'count'" [class.width29]="column == 'empty'"
                [class.width29]="column == 'gmId'">
                {{columnHeaders[indexOfelement]}} </th>

            <td mat-cell *matCellDef="let element" [class.rightAlign]="['count'].includes(column)"
                [class.width24]="column == 'count'" [class.width29]="column == 'empty'"
                [class.width29]="column == 'gmId'">

                <div class="cellHeight" [ngSwitch]="column">

                    <!-- Checkbox column -->
                    <div *ngSwitchCase="'checkBox'">
                        <mat-checkbox color="primary" [checked]="element[column]"
                            (change)="onCheckboxChange(dataSource.indexOf(element), $event.checked, element)">
                        </mat-checkbox>
                    </div>

                    <!-- if column has status -->
                    <div *ngSwitchCase="'status'">
                        <app-type-specific-status [type]=false
                            statusName={{element[column]}}></app-type-specific-status>
                    </div>

                    <div *ngSwitchCase="'gmId'">
                        <app-profile [userId]="element[column]"></app-profile>
                    </div>

                    <div *ngSwitchCase="'count'" class="rightAlign width100">
                        <span [matTooltip]="element[column]">{{cf.formatCompactNumber(element[column])}}</span>
                    </div>

                    <!-- if column has id  for abort in que mngr-->
                    <div *ngSwitchCase="'id'"> <button mat-raised-button color="primary">Abort</button></div>

                    <div class="queueTime" *ngSwitchCase="'queueTime'">
                        <app-duration-show *ngIf="element['status'] ==='queued' "
                            [timeInSec]="element[column]"></app-duration-show>

                        <div *ngIf="element['status'] ==='inprogress'">{{element[column] | durationFormatter}}</div>
                    </div>
                    <div class="cellHeight" [ngSwitch]="column" [class.width-7]="column === 'execThreshold'">
                        <div *ngSwitchCase="'actualThreshold'" class="Criteria" [matTooltip]="element[column]"></div>
                        <div *ngSwitchCase="'execThreshold'" class="percentage" [matTooltip]="element[column]"></div>
                    </div>

                    <!-- Feature workflow expand quality gates -->
                    <div *ngSwitchCase="'tool'" class="ellipses tool" [matTooltip]="element[column]">
                        {{element[column]}}</div>
                    <div *ngSwitchCase="'qualityGateName'" class="ellipses qualityGateName"
                        [matTooltip]="element[column]">{{element[column]}}</div>
                    <!-- END feature workflow expand quality gates -->

                    <!-- Workflow run page-->
                    <div *ngSwitchCase="'duration'">
                        {{element[column] | durationFormatter}}
                    </div>
                    <!-- END workflow run page-->

                    <!-- normal column -->
                    <div *ngSwitchDefault class="width100"> {{element[column] == 0 ? 0 : column == 'tool' ?
                        element[column] : (element[column])}}</div>
                </div>
            </td>
        </ng-container>

        <!-- header row -->
        <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>

        <!-- row of values -->
        <tr mat-row class="example-element-row" *matRowDef="let row; columns: columnsToDisplay"></tr>

        <!-- No data available -->
        <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan=9>
                <app-no-data-available [newData]="getNoData"></app-no-data-available>
            </td>
        </tr>
    </table>
</section>